<template>
  <div class="row justify-content-center" style="">
    <div class="col-12 col-md-10 col-lg-8 col-xl-8">
      <div class="tit text-center">
        <img src="/static/assets/images/ico-file.svg" style="margin-bottom:40px; width:60px;" alt="icone arquivo">
        <h1>Confirmação do cadastro de investidor</h1>
        <p>Esse é o último passo do seu cadastro de investidor. Caso queira, pode voltar e corrigir os dados informados anteriormente antes de clicar em enviar.</p>
      </div>
      <form @submit.prevent="submit">
        <div class="card" style="width: 40rem; margin:0 auto 30px auto;">
          <div class="card-body text-center">
            <p class="card-text">Confirmo que as informações e documentos fornecidos são verdadeiros e concordo expressamente com o inteiro teor dos <a :href="lpUrl+'/termos-de-uso-e-condicoes-para-investidores/'" title="Termos e Condições para investidores">Termos e Condições Para Investidores</a> e <a :href="lpUrl+'/politica-de-privacidade/'" title="Política de Privacidade">Politica de Privacidade</a>, ficando desde já obrigado e sujeito aos direitos e obrigações oriundos dos instrumentos.</p>

          <div class="form-check d-flex justify-content-center">
            <div class="checkboxContainer">
              <input v-model="acceptContract" type="checkbox" class="form-check-input" id="exampleCheck1">
              <span class="checkmark"></span>
            </div>
            <div>
              <label class="form-check-label" for="exampleCheck1"><strong>CONFIRMO E CONCORDO</strong></label>
            </div>
          </div>
          </div>
        </div>
        <div class="text-center fixedOptions">
          <button class="btn btn-lg btn-primary" :disabled="!acceptContract">Enviar <i class="fas fa-check"></i></button>
        </div>
      </form>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../assets/styles/iouu/_mixins.scss";

  .form-check-label {
    @include xs {
      font-size: calcRem(12);
    }
  }

  .card {
    @include mob {
      width: 100% !important;
    }
  }
</style>



<script>
  export default {
    data() {
      return {
        lpUrl:process.env.LP_URL,
        acceptContract: null,
        options: {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        },
        lat: 0,
        long: 0,
      }
    },
    methods: {
      getLocation()
      {
        if(navigator.geolocation)
        {
            navigator.geolocation.getCurrentPosition(this.obterLocalizacao, null, this.options);
        }
      },
      obterLocalizacao(position)
      {
        this.lat = position.coords.latitude;
        this.long = position.coords.longitude;
      },
      submit() {
        this.$emit('submit', { AceitaContratoConfidencialidade: this.acceptContract, Latitude: this.lat, Longitude: this.long })
        this.$ga.event('NewUser', 'send', 'Investidor');
      },
      //tagueamento GA
      taggingGA() {
        this.$ga.page({
          page: '/Informacoes-adicionais/investidor',
          title: 'ConfirmacaoDeCadastroInvestidor',
        })
      },
    },
    created() {
      this.getLocation();

      //tagueamento GA
      this.taggingGA();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationInvestor/PassoConfirmacaoCadastro.vue